import { OrderTotal, orderTotalFromResponse } from './OrderTotal';

export interface MyOrder {
  id: number;
  createdAt: Date;
  customerEmail: string;
  orderTotal: OrderTotal;
}

export const myOrderFromResponse = (responseData: any): MyOrder => ({
  id: responseData.id,
  createdAt: new Date(responseData.created_at),
  customerEmail: responseData.customer_email,
  orderTotal: orderTotalFromResponse(responseData.total),
});
